import React, { useState, useEffect } from 'react';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { Route, Routes, Link, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
// import ReservationsPage from './ReservationsPage';
import BookNow from './BookNow';
import AboutPage from './AboutPage';
import FAQPage from './FAQPage';
import Container from './Container';
import HeroSection from './HeroSection';
import MoreInfo from './MoreInfo';
import './PolaroidGallery.css';
import useScrollAnimation from './useScrollAnimation';
import RequestInfoForm from './RequestInfoForm';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import BlogHome from './BlogHome';
import BlogPost from './BlogPost';
import AdminBlogEditor from './AdminBlogEditor';

function App() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [polies, setPolaroids] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);

  const handleRequestInfo = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };
  
  useEffect(() => {
    if (location.hash) {
      const section = document.getElementById(location.hash.substring(1)); // Remove the "#" from the hash
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  useScrollAnimation();

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      // Clear hash and query parameters
      navigate("/", { replace: true }); // Reset the URL to just "/"
      // window.history.pushState({}, document.title, "/"); // Ensure the URL is clean
      window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scroll to the top
    } else {
      navigate("/");
    }
  };

  const prompts = [
    "Welcome to Snappo! Stay updated with event details here.",
    "Happy travels! Document your trip here.",
    "Who made it to Italy? Show us what you've been up to!",
    "Who's out sightseeing? Send us a pic in front of a historic landmark",
  ];

    const reviews = [
    "Snappo was our secret weapon. Everyone knew what to do, and the video memories were amazing.",
    "It was so easy to use as a Bride. Loved it! Highly recommend!",
    "I love how connected we felt the entire week!",
    "It felt like a private Instagram just for our wedding weekend. We didn’t miss a single moment.",
  ];

  const captions = [
    "Happy travels! Document your trip here.",
    "Who made it to Italy? Show us what you've been up to!",
    "Boat Day is finally here! Show us what your crew is up to",
    "Who's out sightseeing? Send us a pic in front of a historic landmark",
    "The bride and groom have arrived! Snap a pic with your date",
    "Boat Day is finally here! Show us what your crew is up to",
    "The bride and groom have arrived! Snap a pic with your date",
    "Happy travels! Document your trip here."
  ];

  useEffect(() => {
    const fetchImageUrls = async () => {
      const imagePaths = [
        "FCMImages/IMG_1.webp",
        "FCMImages/IMG_2.webp",
        "FCMImages/IMG_3.webp",
        "FCMImages/IMG_4.webp",
        "FCMImages/IMG_5.webp",
        "FCMImages/IMG_6.webp",
        "FCMImages/IMG_7.webp",
        "FCMImages/IMG_8.webp",
        "FCMImages/IMG_9.webp",
        "FCMImages/IMG_10.webp",
      ];

      const polaroids = [
        "FCMImages/IMG_11.webp",
        "FCMImages/IMG_13.webp",
        "FCMImages/IMG_14.webp",
        "FCMImages/IMG_15.webp",
        "FCMImages/IMG_16.webp",
        "FCMImages/IMG_17.webp",
      ];

      try {
        const urls = await Promise.all(
          imagePaths.map(async (path) => {
            const imageRef = ref(getStorage(), path);
            return await getDownloadURL(imageRef);   
          })
        );
        const polaroidUrls = await Promise.all(
          polaroids.map(async (path) => {
            const imageRef = ref(getStorage(), path);
            return await getDownloadURL(imageRef);
          })
        );

        setPolaroids(polaroidUrls);
        setImageUrls(urls);
      } catch (error) {
        console.error("Error fetching image URLs:", error);
      }
    };
    fetchImageUrls();
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1>
          <Link to="/" onClick={handleLogoClick}>
            {/* <img src='/logo_snappo.png' alt='snappo' className="logo-image" ></img> */}
            snappo
          </Link>
        </h1>

        {/* New wrapper for horizontal nav links (visible on desktop) */}
        <div className="nav-wrap">
          <ul className="nav-links">
            <li><Link to="/#features">Intro</Link></li>
            <li><Link to="/#faq">FAQ</Link></li>
            <li><Link to="/#eventhub">How it works</Link></li>
            <li><Link to="/eventhub">Event Hub</Link></li>
            <li><Link to="/reservations">Book Now</Link></li>
          </ul>
        </div>

        <nav>
          <button className="menu-button" onClick={toggleDropdown}>
            <span className="material-icons">menu</span>
          </button>
          <ul className={`header-dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
            <li>
              <Link to="/#features" onClick={() => setIsDropdownOpen(false)}>
                Intro
              </Link>
            </li>
            <li>
              <Link to="/reservations" onClick={() => setIsDropdownOpen(false)}>
                Book Now
              </Link>
            </li>
            <li>
              <Link to="/#eventhub" onClick={() => setIsDropdownOpen(false)}>
                How It Works
              </Link>
            </li>
            <li>
              <Link to="/eventhub" onClick={() => setIsDropdownOpen(false)}>
                Event Hub
              </Link>
            </li>

            <li>
              <Link to="/#faq" onClick={() => setIsDropdownOpen(false)}>
                FAQ
              </Link>
            </li>
          </ul>
        </nav>
      </header>

      <main>
      <Routes>
        <Route 
          path="/" 
          element={
            <Container>
              <HeroSection
                images ={imageUrls}
                title={
                  <>
                  Host<br /> 
                  your private event.
                  </>
                }
                // subtitle={
                //   <>
                //   Snappo is your personalized wedding hub — one simple link for everything.<br /> 
                //   Share your itinerary, favorite spots, photos, videos, and more <br /> 
                //   in a private social feed. No app required.<br /> 
                //   </>
                // }
                ctaText="Intro"
                ctaLink="/#features"
                ctaText2="Book Now"
                ctaLink2="/reservations"
              />
              
              <div className="communication-tools">
                
                <div className="text-section">
                  <h2>CONNECT. SHARE. REMEMBER.</h2>
                  <p>The Ultimate</p>
                  <p>Private Event Platform</p>
                </div> 

                <div className="image-section">
                  <img 
                    className="phone-image"
                    src="https://firebasestorage.googleapis.com/v0/b/vip-feed-d30d0.appspot.com/o/FCMImages%2FIMG_73456.webp?alt=media&token=da89d5d2-abce-4ba4-815b-5abc9bd09a60"
                    alt="Snappo wedding and event text prompts and private event guest feed"
                  />
                  <img
                    className="phone-image"
                    src="https://firebasestorage.googleapis.com/v0/b/vip-feed-d30d0.appspot.com/o/FCMImages%2FIMG_5982-removebg-preview.webp?alt=media&token=aba63770-5a31-42f0-bf2a-46e9ef0c4b80" 
                    alt="Snappo Wedding and Event Itinerary and Planning Tool"
                  />
                </div>
              </div>
            <section id="features">
              <div className="communication-tools-brokenout-reverse">
                <div className="text-section">
                  <h2>Get started</h2>
                  <p>What is Snappo?</p>
                  <h1>A Hosting Service for Your Event.</h1>
                  <h3>Our platform provides a hosted virtual space for weddings, parties, and celebarations - a digital event platform where your guests connect and share memories together.</h3>
                  <h3>No app required.</h3>
                  <h3>                  
                    <>
                    <br/>
                    </>
                  </h3>
                  <h3>🗺️ View your full weekend itinerary (with maps and directions)</h3>
                  <h3>📍 Discover your local recommendations (bars, coffee shops, hotels, and more)</h3>
                  <h3>📸 Drop real-time videos, selfies, and memories</h3>
                  <h3>💬 Stay connected with group chats, alerts, and schedule updates</h3>
                  <h3>✨ Engage with fun prompts and content curated by you</h3>
                  <h3>                  
                    <>
                    <br/>
                    </>
                  </h3>
                </div>
                <div className='feature-wrap'>
                  <div className='feature-content'>
                    <div className='feature-icon'>
                      {/* <div className='feature-text'>
                        Step 1
                      </div> */}
                      <span className="material-icons-outlined">
                        event
                      </span>                  
                    </div>
                    <div className='feature-text'>
                       Create Your Link
                    </div>
                    <div className='feature-paragraph'>
                      Customize your event platform using our EventHub.
                    </div>
                  </div>

                  <div className='feature-content'>  
                    <div className='feature-icon'>
                      {/* <div className='feature-text'>
                        Step 2
                      </div> */}
                      <span className="material-icons-outlined">
                        groups
                      </span>                  
                    </div>
                    <div className='feature-text'>
                      Share It With Guests
                    </div>
                    <div className='feature-paragraph'>
                      Upload your guest list and send via link or QR Code.
                    </div>
                  </div>

                  <div className='feature-content'>
                    <div className='feature-icon'>
                      {/* <div className='feature-text'>
                        Step 3
                      </div> */}
                      <span className="material-icons-outlined">
                        textsms
                      </span>                
                    </div>
                    <div className='feature-text'>
                      Guests Join the Fun
                    </div>
                    <div className='feature-paragraph'>
                      Texts, prompts, photo and video sharing.
                    </div>
                  </div>

                  <div className='feature-content'>
                    <div className='feature-icon'>
                      {/* <div className='feature-text'>
                        Step 4
                      </div> */}
                      <span className="material-icons-outlined">
                        photo_library
                      </span>                
                    </div>
                    <div className='feature-text'>
                      Collect the Memories
                    </div>
                    <div className='feature-paragraph'>
                      Revisit it all in your post-event gallery.
                    </div>
                  </div>
                </div>
              </div>

                <div className="communication-tools-brokenout">
                  <div className="text-section">
                    <h2>CONNECT.</h2>
                    <p>Engage with your guests</p>
                    <h1>Curated prompts, event updates and reminders.</h1>
                  </div>
                  <div className="image-section">
                    <div className="prompt-gallery">
                      {prompts.map((prompt, index) => (
                        <div className="prompt" key={index}>
                          <div className="prompt-caption">{prompt}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
              <div className="communication-tools-brokenout-reverse">
                <div className="text-section">
                  <h2>SHARE.</h2>
                  <p>Capture every perspective</p>
                  <h1>Candid Moments From the People You Love.</h1>
                </div>
                <div className="image-section">
                  <div className={"polaroid-gallery"}>
                    {polies.map((url, index) => (
                      <div
                        className="polaroid"
                        key={index}
                        style={{ '--rotation': `${Math.random() * 20 - 10}deg` }}
                      >
                        <img src={url} alt={`Polaroid ${index}`} />
                        <div className="polaroid-caption">{captions[index]}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="communication-tools-2"
                style={{
                  backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/vip-feed-d30d0.appspot.com/o/FCMImages%2FIMG_12.webp?alt=media&token=40f9a76f-cff0-40cc-8b06-451957bfb47c')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              >
                <div className="text-section">
                  <h2>Remember.</h2>
                  <p>Create lasting memories</p>
                  <h1>Digital photo album to cherish the memories.</h1>
                </div>
              </div>

              <section id='eventhub'>
                <div className="communication-tools-brokenout">
                  <div className="text-section">
                    <h2>Event Hub.</h2>
                    <p>Personalize your event platform</p>
                    <h1>Built for the trip, not just the ceremony.</h1>
                    <h3>💬 Keep everyone connected</h3>
                    <h3>📍 Share locations & directions</h3>
                    <h3>🕒 Send schedule reminders</h3>
                    <h3>🧭 Share travel tips & recommendations</h3>
                    {/* <h3>
                      <>
                      <br />
                      </>
                    </h3> */} 
                  </div>
                  <div className="image-section">
                    <video
                      className="phone-video"
                      muted
                      autoPlay
                      loop
                      playsInline
                      >
                      <source
                        src="https://firebasestorage.googleapis.com/v0/b/vip-feed-d30d0.appspot.com/o/FCMImages%2FEventHubMovie2.mp4?alt=media&token=748c737b-c35a-406f-8530-134f859eb50c"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </section>

                <div className="communication-tools-reviews">
                  <div className="text-section-reviews">
                    <h2>Testimonials.</h2>
                    <p>Loved By All</p>
                    {/* <p> (And Guests)</p> */}

                    <div className="smooth-carousel reviews-carousel">
                      <div className="carousel-track">
                        {[...reviews, ...reviews, ...reviews].map((review, index) => (
                          <div key={index} className="review-slide">
                            <p className="review-text">"{review}"</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              
              {/* <div className='feature-wrap'>
                <div className='feature-content'>
                  <div className='feature-icon'>
                    <span className="material-icons-outlined">
                      chat
                    </span>                  
                  </div>
                  <div className='feature-text'>
                    Scheduled Prompts
                  </div>
                  <div className='feature-paragraph'>
                    Engage and connect with your guests throughout the entire event.
                  </div>
                </div>

                <div className='feature-content'>  
                  <div className='feature-icon'>
                    <span className="material-icons-outlined">
                      event
                    </span>                  
                  </div>
                  <div className='feature-text'>
                    Event Details
                  </div>
                  <div className='feature-paragraph'>
                    Itinerary, locations, and contacts all in one platform.
                  </div>
                </div>

                <div className='feature-content'>
                  <div className='feature-icon'>
                    <span className="material-icons-outlined">
                      signal_cellular_alt
                    </span>                
                  </div>
                  <div className='feature-text'>
                    No Download Required
                  </div>
                  <div className='feature-paragraph'>
                    Links are sent through SMS for quick access.
                  </div>
                </div>
              </div> */}

              {/* FAQ Content */}
              <section id='faq'>
                <FAQPage/>
              </section>
              
              <div className='closing-section'>
                <div className='closing-wrap'>
                  <h2>Host Your Event With Us</h2>
                  <div className='button-wrap'>
                    <button className='book-now-button'>
                      <Link to="/reservations">Book Now</Link>
                    </button>
                    <button className="outline-button" onClick={handleRequestInfo}>
                      Get in Touch
                    </button>
                  </div>
                </div>
              </div>

            </Container>
          }
        />
        <Route path="/reservations" element={<Container><BookNow /></Container>} />
        <Route path="/eventhub" element={<Container><MoreInfo /></Container>} />
        <Route path="/about" element={<Container><AboutPage /></Container>} />
        <Route path="/faq" element={<Container><FAQPage /></Container>} />
        <Route path="/privacy-policy" element={<Container><PrivacyPolicy /></Container>} />
        <Route path="/terms-of-service" element={<Container><TermsOfService /></Container>} />
        <Route path="/blog" element={<BlogHome />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin/blog/new" element={<AdminBlogEditor />} />

      </Routes>

      {showForm && <RequestInfoForm onClose={handleCloseForm} />}
      </main>

      <footer>
        <p>&copy; 2025 Snappo LLC. All rights reserved.</p>
        <p>
        <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        |
        <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
        </p>
      </footer>
    </div>
  );
}

// const storage = getStorage();

// function HomePage( {imageUrls} ) {

//   // const prompts = [
//   //   "Snap a pic!",
//   //   "Send us a pic of your travels",
//   //   "How well do you know the bride or groom? Click here to take a quiz.",
//   //   "Welcome to Snappo! Stay updated with event details here.",
//   //   "The ceremony is about to begin, don't forget to silence your phones."
//   // ];

//   // const reviews = [
//   //   "This app made my event so memorable!",
//   //   "The photo-sharing feature is fantastic.",
//   //   "Loved the personalized event hub. Highly recommend!",
//   //   "I love how connected we felt the entire week!",
//   //   "The photo-sharing feature is fantastic.",
//   // ];

//   return (
//     <div className="homepage">
//       {/* <h1>The Ultimate</h1>
//       <h2>Private Social Platform</h2>
//       <h3>Connect with your guests through a platform curated for your private event.</h3>
//       <div className="smooth-carousel">
//         <div className="carousel-track">
//           {[...imageUrls, ...imageUrls, ...imageUrls, ...imageUrls].map((url, index) => (
//             <div key={index} className="carousel-itm">
//               <img src={url} alt={`Event ${index + 1}`} />
//             </div>
//           ))}
//         </div>
//       </div> */}

//       {/* <div className="smooth-carousel reviews-carousel">
//         <div className="carousel-track">
//           {[...prompts, ...prompts, ...prompts].map((prompt, index) => (
//             <div key={index} className="prompt-slide">
//               <p className="prompt-text">"{prompt}"</p>
//             </div>
//           ))}
//         </div>
//       </div> */}

//       {/* <div className="card-features">
//         <Card title="Connect" 
//           description="Send mass texts and keep your guests engaged seamlessly.">
//         </Card>
//         <Card title="Share"
//           description="Personalized social feeds to share moments in real-time.">
//         </Card>
//         <Card title="Remember"
//           description="Receive a digital and physical photo album of your event memories.">
//         </Card>
//       </div> */}


      

//       {/* <div className="communication-tools">
//         <div className="image-section">
//           <img 
//             className="phone-image"
//             src="https://firebasestorage.googleapis.com/v0/b/vip-feed-d30d0.appspot.com/o/FCMImages%2FIMG_5982-removebg-preview.png?alt=media&token=824768f7-994b-4a46-83fb-b882e58308f5" 
//             alt="Custom Social Feed on iPhone"
//           />
//         </div>
//         <div className="text-section">
//           <h2>Share</h2>
//           <p>
//             A platform to capture every perspective.
//           </p>
//         </div>
//       </div>

//       <div className="communication-tools">
//         <div className="text-section">
//           <h2>Remember</h2>
//           <p>
//             A platform to capture every perspective.
//           </p>
//         </div>
//       </div> */}

//       {/* <div className="smooth-carousel reviews-carousel">
//         <div className="carousel-track">
//           {[...reviews, ...reviews, ...reviews].map((review, index) => (
//             <div key={index} className="review-slide">
//               <p className="review-text">"{review}"</p>
//             </div>
//           ))}
//         </div>
//       </div> */}

//     </div>

    
//   );
// }

export default App;